import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../Hooks/useFetch";
import { transactionsURL } from "../Hooks/URL";
import { userContext } from "../Contexts/userContext";
import Transactions from "../Templates/Home/Transactions/Transactions";

function TransactionsPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Open, setOpen] = useState(false);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState(true);
  const [filters, setFilters] = useState({
    manualTransactionType: "",
  });

  const getFilterQueryString = (filters) => {
    return Object.entries(filters)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => `${key}=${value}`)
      .join("&");
  };

  const [transactions, setTransactions] = useState([]);
  const [transactionsSummary, setTransactionsSummary] = useState({});
  const [transactionsNumber, setTransactionsNumber] = useState(0);
  const { data, loading, error } = useFetch(
    transactionsURL,
    page,
    rowsPerPage,
    search,
    null,
    false,
    `${sortBy ? `&sortBy=${sortBy}` : ""}${
      sortOrder ? `&sortDesc=${sortOrder}` : ""
    }${
      getFilterQueryString(filters) ? `&${getFilterQueryString(filters)}` : ""
    }`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setTransactions(data.data?.data?.rows);
      setTransactionsNumber(data.data?.data?.totalCount);
      setPageCount(data.data?.data?.numberOfPages);
      setTransactionsSummary(data.data?.data?.totalSummary);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "transactions", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };

  const handleSortOrderChange = (event) => {
    setSortOrder(event.target.value);
  };

  const handleFilterChange = (event) => {
    setFilters({
      ...filters,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Transactions
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      transactions={transactions}
      totalSum={transactions?.totalSum}
      transactionsNumber={transactionsNumber}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setTransactions={setTransactions}
      sortBy={sortBy}
      sortOrder={sortOrder}
      handleSortChange={handleSortChange}
      handleSortOrderChange={handleSortOrderChange}
      handleFilterChange={handleFilterChange}
      filters={filters}
      setPage={setPage}
      transactionsSummary={transactionsSummary}
      getFilterQueryString={getFilterQueryString}
    />
  );
}

export default TransactionsPage;
